import React from 'react';
import { N600 } from '@atlaskit/theme/colors';
import CodeIcon from '@atlaskit/icon/core/migration/angle-brackets--code';
export const extractProgrammingLanguage = jsonLd => {
  const programmingLanguage = jsonLd['schema:programmingLanguage'];
  if (programmingLanguage) {
    return {
      text: programmingLanguage,
      icon: /*#__PURE__*/React.createElement(CodeIcon, {
        LEGACY_size: "small",
        label: "code",
        color: `var(--ds-icon-subtle, ${N600})`
      })
    };
  }
};